// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--zXwMQ","label":"dd31006766--label--hHDW6"};